import { useNavigate } from "react-router-dom";

export default function AdminNav() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await fetch("/api/logout.php", { method: "POST" });
    navigate("/login");
  };

  return (
    <nav className="bg-gray-800 text-white px-6 py-3 flex justify-between items-center shadow">
      <div className="text-xl font-bold">Admin Dashboard</div>
      <button
        onClick={handleLogout}
        className="bg-red-600 hover:bg-red-700 px-4 py-1 rounded text-sm"
      >
        Logout
      </button>
    </nav>
  );
}
